module.exports = __webpack_public_path__ + "img/wlw_s.9788545.png";